var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-taxonomies',{attrs:{"items":_vm.value.children,"grid-options":_vm.taxonomyOptions,"request-options":{ filter: { id: { neq: _vm.value.id } } },"multiple":"","show-chips":"","errors":_vm.chipErrors},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }